import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ListingProductCart from "../../component/ListingProductCart";
import service from "services/service";
import SEO from "component/SEO/SEO";
import "../ProductListing/ProductListing.css";

const CATEGORY_DATA = {
  "banarasi-sarees": {
    title: "Banarasi Sarees",
    description: "Buy Banarasi Sarees online at Rekha Collection starting from ₹950. Authentic Banarasi silk sarees with free delivery in Kolkata & West Bengal. রেখা কালেকশনে বানারসি শাড়ি কিনুন।",
    keywords: "banarasi saree, banarasi saree online, banarasi silk saree kolkata, বানারসি শাড়ি",
    category: "Banarasi Saree",
    price: "₹950",
  },
  "silk-sarees": {
    title: "Silk Sarees",
    description: "Buy Silk Sarees online at Rekha Collection starting from ₹650. Premium silk sarees with free delivery in Kolkata & West Bengal. রেখা কালেকশনে সিল্ক শাড়ি কিনুন।",
    keywords: "silk saree, silk saree online, silk saree kolkata, সিল্ক শাড়ি",
    category: "Silk Saree",
    price: "₹700",
  },
  "gujarati-sarees": {
    title: "Gujarati Sarees",
    description: "Buy Gujarati Sarees online at Rekha Collection. Beautiful Gujarati style sarees with free delivery in Kolkata & West Bengal. রেখা কালেকশনে গুজরাটি শাড়ি কিনুন।",
    keywords: "gujarati saree, gujarati saree online, গুজরাটি শাড়ি",
    category: "Gujarati Saree",
    price: "₹700",
  },
  "cotton-sarees": {
    title: "Pure Cotton Sarees",
    description: "Buy Pure Cotton Sarees online at Rekha Collection. Comfortable cotton sarees for daily wear with free delivery in Kolkata & West Bengal. রেখা কালেকশনে কটন শাড়ি কিনুন।",
    keywords: "cotton saree, pure cotton saree online, কটন শাড়ি, সুতি শাড়ি",
    category: "Cotton Saree",
    price: "₹400",
  },
  "mushroom-sarees": {
    title: "Mushroom Sarees",
    description: "Buy Mushroom Sarees online at Rekha Collection. Trendy mushroom fabric sarees with free delivery in Kolkata & West Bengal.",
    keywords: "mushroom saree, mushroom saree online, মাশরুম শাড়ি",
    category: "Mushroom Saree",
    price: "₹750",
  },
  "handloom-sarees": {
    title: "Handloom Sarees",
    description: "Buy Handloom Sarees online at Rekha Collection. Authentic handloom sarees from Bengal with free delivery in Kolkata & West Bengal. রেখা কালেকশনে হ্যান্ডলুম শাড়ি কিনুন।",
    keywords: "handloom saree, bengal handloom saree, হ্যান্ডলুম শাড়ি, তাঁত শাড়ি",
    category: "Handloom Saree",
    price: "₹400",
  },
  "kantha-stitch-sarees": {
    title: "Kantha Stitch Sarees",
    description: "Buy Kantha Stitch Sarees online at Rekha Collection. Traditional Bengali kantha embroidery sarees with free delivery. রেখা কালেকশনে কাঁথা স্টিচ শাড়ি কিনুন।",
    keywords: "kantha stitch saree, kantha saree online, কাঁথা স্টিচ শাড়ি",
    category: "Kantha Stitch Saree",
    price: "₹1000",
  },
  "maslin-sarees": {
    title: "Maslin Sarees",
    description: "Buy Maslin Sarees online at Rekha Collection. Lightweight maslin fabric sarees with free delivery in Kolkata & West Bengal.",
    keywords: "maslin saree, maslin saree online, মসলিন শাড়ি",
    category: "Maslin Saree",
    price: "₹750",
  },
  "dual-tone-sarees": {
    title: "Dual Tone Sarees",
    description: "Buy Dual Tone Sarees online at Rekha Collection. Elegant dual tone color sarees with free delivery in Kolkata & West Bengal.",
    keywords: "dual tone saree, dual tone saree online, ডুয়াল টোন শাড়ি",
    category: "Dual Tone Saree",
    price: "₹700",
  },
  "digital-print-sarees": {
    title: "Digital Print Sarees",
    description: "Buy Digital Print Sarees online at Rekha Collection. Modern digital printed sarees with free delivery in Kolkata & West Bengal.",
    keywords: "digital print saree, digital print saree online, ডিজিটাল প্রিন্ট শাড়ি",
    category: "Digital Print Saree",
    price: "₹450",
  },
  "kurti": {
    title: "Kurti",
    description: "Buy Kurti online at Rekha Collection starting from ₹200. Trendy kurtis for women with free delivery in Kolkata & West Bengal. রেখা কালেকশনে কুর্তি কিনুন।",
    keywords: "kurti online, kurti kolkata, women kurti, কুর্তি অনলাইন",
    category: "Kurti",
    price: "₹200",
  },
  "salwar-suit": {
    title: "3pc Salwar Suit",
    description: "Buy 3 Piece Salwar Suit online at Rekha Collection starting from ₹400. Complete salwar suit sets with free delivery in Kolkata & West Bengal. রেখা কালেকশনে সালোয়ার সুট কিনুন।",
    keywords: "salwar suit online, 3 piece suit, salwar kameez kolkata, সালোয়ার সুট",
    category: "Salwar Suit",
    price: "₹400",
  },
};

const CategoryPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const categoryInfo = CATEGORY_DATA[slug];

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const params = { category: categoryInfo?.category || slug };
        const response = await service.getAllProducts(params);
        setProducts(response.data.data || []);
      } catch (error) {
        console.error("Error fetching category products:", error);
      } finally {
        setLoading(false);
      }
    };
    if (categoryInfo) fetchProducts();
  }, [slug]);

  if (!categoryInfo) {
    return <div style={{ textAlign: "center", padding: "50px" }}>Category not found</div>;
  }

  return (
    <>
      <SEO
        title={categoryInfo.title}
        description={categoryInfo.description}
        keywords={categoryInfo.keywords}
        url={`/collections/${slug}`}
      />
      <div className="listing-1">
        <div style={{ padding: "20px 30px" }}>
          <h1 style={{ fontSize: "1.5rem", marginBottom: "5px" }}>{categoryInfo.title}</h1>
          <p style={{ color: "#666", fontSize: "0.9rem" }}>Starting from {categoryInfo.price} | Free Delivery in Kolkata & West Bengal</p>
        </div>
        <div className="listing__row">
          <div className="listing__grid">
            {loading ? (
              <p style={{ padding: "20px" }}>Loading...</p>
            ) : products.length > 0 ? (
              products.map((product, index) => (
                <div
                  key={index}
                  onClick={() => navigate(`/product/${product._id}`)}
                  className="listing_item"
                >
                  <ListingProductCart
                    image={product.primaryImage}
                    title={product.name}
                    brand={product.category}
                    price={product.discountPrice}
                    oldPrice={product.price}
                    discount={product.discount}
                    isNewArrival={product.isNew}
                    colour={product.color}
                    productId={product._id}
                  />
                </div>
              ))
            ) : (
              <p style={{ padding: "20px" }}>No products found in this category.</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryPage;
